interface InformationBoardSectionProps {
  header?: string;
  children: React.ReactNode | null;
}
export const InformationBoardSection: React.FC<InformationBoardSectionProps> = ({ header, children }) => {
  return (
    <div className="flex flex-col justify-between items-start gap-2">
      {header && <p className="text-s-sb uppercase text-base-30">{header}</p>}
      <div className="flex flex-row items-start w-full gap-4">{children}</div>
    </div>
  );
};
